import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';

import AccountsDisplay from 'components/Accounts/AccountsDisplay';

const SelectUser = (props) => {

  const [openAccountsDisplay, setOpenAccountsDisplay] = useState(false);
  const [currentUserId, setCurrentUserId] = useState("");

  const showAccountsDisplay = (userId) => {
    setCurrentUserId(userId);
    setOpenAccountsDisplay(true);
  };

  const hideAccountsDisplay = () => {
    setCurrentUserId("");
    setOpenAccountsDisplay(false);
  };

  return (
    <Box>
      { openAccountsDisplay ?
        <AccountsDisplay
          salesOrders={props.salesOrders.filter(salesOrder => salesOrder.userId === currentUserId && salesOrder.payments.length > 0)}
          allSalesOrders={props.salesOrders.filter(salesOrder => salesOrder.userId === currentUserId)}
          expenses={props.expenses.filter(expense => expense.userId === currentUserId)}
          products={props.products}
          customers={props.customers}
          user={props.user}
          hideAccountsDisplay={hideAccountsDisplay}
        /> :
			  <Card>
				  <CardContent>
            <Box style={{ minHeight: 140, textAlign: 'center' }}>
              <Typography
                style={{ marginTop: 8, marginBottom: 4 }}
                color="textPrimary"
                variant="h5"
              >
                Pick a user
              </Typography>
              <Divider />
              <Grid
                container
                justify='center'
                spacing={3}
                style={{ textAlign: 'center' }}
              >
                <Grid
                  item
                  md={4}
                  xs={12}
                >
                  <ButtonGroup color="primary" aria-label="text primary button group" style={{ marginTop: 24, width: '100%', height: 56 }}>
                    { props.user.standardUsers ? props.user.standardUsers.map(user => (
                      <Button
                        key={user.id}
                        style={{ flex: 1 }}
                        onClick={showAccountsDisplay.bind(this, user.id)}
                      >
                        {user.name}
                      </Button>
                    )) : null }
                  </ButtonGroup>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      }
    </Box>
  )
};

export default SelectUser;